<div *ngIf="isOpen"
  class="fixed inset-0 bg-black/50 flex items-center justify-center z-[9999] p-4"
  (click)="onBackdropClick()">
  <div
    class="bg-white rounded-3xl max-w-sm w-full shadow-2xl overflow-hidden transform transition-all duration-300"
    (click)="$event.stopPropagation()">

    <!-- Top accent bar -->
    <div class="h-1.5 w-full bg-gradient-to-r from-[#D31148] to-[#ff6b9d]"></div>

    <div class="px-7 py-7">

      <!-- Icon -->
      <div class="flex justify-center mb-5">
        <div class="w-16 h-16 rounded-full bg-[#FFF0F3] flex items-center justify-center">
          <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="9" stroke="#D31148" stroke-width="2"
              stroke-linecap="round" stroke-linejoin="round" />
            <path d="M12 7v5l3.5 2" stroke="#D31148" stroke-width="2"
              stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </div>
      </div>

      <!-- Title -->
      <h3 class="text-center text-xl font-bold text-gray-900 mb-2">Friend Request On Hold</h3>

      <!-- Message -->
      <p class="text-center text-sm text-gray-500 leading-relaxed mb-7">
        You and this user have a recent request between you, so you'll need to wait
        <span class="font-bold text-[#D31148]">{{ hoursLabel }}</span>
        before you can send another one.
      </p>

      <!-- Buttons -->
      <div class="flex flex-col gap-3">
        <button (click)="onClose()"
          class="w-full py-3 rounded-xl bg-[#D31148] text-white font-semibold text-sm
                 hover:bg-[#b80e3d] active:scale-[0.98] transition-all">
          Got it
        </button>
      </div>

    </div>
  </div>
</div>
